import { Col, Flex, Row, Typography } from "antd";
import { Outlet } from "react-router-dom";
import Footer from "../../components/v2/Footer/Footer";
import style from "./ResetPassword.module.css";

const { Title, Paragraph } = Typography;

export default function ResetPassword() {
  return (
    <>
      <Row style={{ minHeight: "calc(100vh - 32px)" }}>
        <Col xs={24} lg={15} xl={14}>
          <Row style={{ height: "100%" }}>
            <Col
              xs={{ span: 22, offset: 1 }}
              lg={{ span: 12, push: 6 }}
              xl={{ span: 12, push: 10 }}
            >
              <Flex
                vertical
                align="center"
                justify="space-between"
                style={{
                  height: "100%",
                }}
              >
                <Flex
                  align="center"
                  justify="center"
                  vertical
                  flex={1}
                  style={{ paddingTop: "6.25rem" }}
                >
                  <Outlet />
                </Flex>

                <Paragraph
                  style={{
                    marginTop: "5rem",
                    marginBottom: "3.75rem",
                    textAlign: "center",
                  }}
                >
                  For any questions, contact us at{" "}
                  <a href="mailto:support@bevz.com">support@bevz.com</a>
                </Paragraph>
              </Flex>
            </Col>
          </Row>
        </Col>
        <Col xs={0} lg={9} xl={10} className={style.Left}></Col>
      </Row>
      <Footer />
    </>
  );
}
